import { ItemsContainerWebglSettingsConverter } from "./items-container-webgl-settings-converter";
import { ObjectCreator } from "../../../../../../web-graphics";

export class ColumnGridWebglSettingsConverter extends ItemsContainerWebglSettingsConverter {
  constructor(viewObjectConverters) {
    super(viewObjectConverters);
  }

  _copyRow(rowSettings) {
    if (rowSettings === undefined) {
      return undefined;
    }
    let rowSettingsCopy = {
      height: rowSettings.height.copy()
    };
    ObjectCreator.addFields(rowSettings, rowSettingsCopy, ["height", "item"]);
    let convertedItemSettings = this._copyItem(rowSettings.item);
    if (convertedItemSettings !== undefined) {
      rowSettingsCopy.item = convertedItemSettings;
    }
    return rowSettingsCopy;
  }

  _copyColumn(columnSettings) {
    if (columnSettings === undefined) {
      return undefined;
    }
    let columnSettingsCopy = {
      width: columnSettings.width.copy(),
      rowsSpace: columnSettings.rowsSpace.copy(),
      rows: []
    };
    ObjectCreator.addFields(columnSettings, columnSettingsCopy, ["width", "rowsSpace", "rows"]);
    columnSettingsCopy.rows = [];
    for (let rowIndex = 0; rowIndex < columnSettings.rows.length; rowIndex++) {
      let rowSettingsCopy = this._copyRow(columnSettings.rows[rowIndex]);
      if (rowSettingsCopy !== undefined) {
        columnSettingsCopy.rows.push(rowSettingsCopy);
      }
    }
    return columnSettingsCopy;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    if (settings.columns === undefined || this.viewObjectConverters === undefined || this.viewObjectConverters.size == 0) {
      return settingsCopy;
    }
    settingsCopy.columns = [];
    for (let columnIndex = 0; columnIndex < settings.columns.length; columnIndex++) {
      let columnSettingsCopy = this._copyColumn(settings.columns[columnIndex]);
      if (columnSettingsCopy !== undefined) {
        settingsCopy.columns.push(columnSettingsCopy);
      }
    }
    return settingsCopy;
  }
}
